<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      width="1200px"
      height="492px"
      @close="handleClose"
      :before-close="handleClose"
      >
      <div slot="title" class="dialog-title">
        <span style="font-weight: 600;">{{ title }}</span>文档差评及整改明细
      </div>
      <el-table
      :data="pageDataOftable"
      class="rectification-boards-table"
      row-class-name="boards-table-column"
      height="400"
      width="1080"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          height="40"
        >
      </el-table-column>
        <el-table-column
          prop="docTypeSub"
          label="文档类型"
          width="80">
          <template  slot-scope="scope">
            <span class="boards-table-row">{{ scope.row.docTypeSub | formatDocumentEnums }}</span>
          </template>
        </el-table-column>
      <el-table-column
        prop="title"
        label="文档标题"
        width="200">
        <template  slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.title" placement="top-start">
            <span class="boards-table-row">{{ scope.row.title }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="评价时间"
        width="150">
        <template  slot-scope="scope">
          <span class="boards-table-row">{{ scope.row.createTime | formatTime }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="questionCause"
        label="问题原因"
        width="120">
          <template  slot-scope="scope">
            <span class="boards-table-row">{{ scope.row.questionCause | formatReasonEnums }}</span>
          </template>
      </el-table-column>
      <el-table-column
        prop="createUser"
        label="评价人"
        width="130">
        <template  slot-scope="scope">
          <span class="boards-table-row">{{ scope.row.createUser }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="questionDesc"
        label="问题描述"
        width="200">
        <template  slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.questionDesc" placement="top-start">
            <span class="boards-table-row">{{ scope.row.questionDesc }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="handleStatus"
        label="处理状态"
        width="100">
          <template  slot-scope="scope">
            <span class="boards-table-row">{{ scope.row.handleStatus | formatStatusEnums }}</span>
          </template>
      </el-table-column>
      <el-table-column
        prop="userExplain"
        label="处理说明"
        width="220">
        <template  slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.userExplain" placement="top-start">
            <span class="boards-table-row">{{ scope.row.userExplain }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="handleUser"
        label="处理人"
        width="120">
        <template  slot-scope="scope">
          <span class="boards-table-row">{{ scope.row.handleUser }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      id="rectificationPagination"
      :total="listQuery.total"
      :pageSizes="[10]"
      :pageSize="listQuery.pageSize"
      :currentPage.sync="listQuery.page"
      :reloadTableData="paginationChange"
    />
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import Pagination from '@/components/Pagination'
import { documentEnums, statusEnums, reasonEnums } from './data.js'
import request from '@/utils/request'

export default {
  components: { Pagination },
  props: {
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    unitCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      listQuery: {
        page: 1,
        pageSize: 10,
        total: 0

      },
      pageDataOftable: []
    }
  },
  filters: {
    // 1：对接方案文档-api文档，2：对接方案文档-业务介绍，3：对接方案文档-开发说明,4:对接方案文档-联调指南，5：对接方案文档-常见问题，
    // 6：对接方案-消息文档，7：平台文档-外网新手指南,8: 平台文档-外网技术文档
    formatDocumentEnums(value) {
      const hashMap = new Map()
        .set(1, 'API文档')
        .set(2, '业务介绍')
        .set(3, '开发说明')
        .set(4, '联调指南')
        .set(5, '常见问题')
        .set(6, '消息文档')
        .set(7, '外网新手指南')
        .set(8, '外网技术文档')

      return hashMap.get(value) || ''
    },
    // 1:内容不详细,2:文档更新不及时,3:内容有误,4:视觉体验差,5:其他
    formatReasonEnums(value) {
      const hashMap = new Map()
        .set(1, '内容不详细')
        .set(2, '文档更新不及时')
        .set(3, '内容有误')
        .set(4, '视觉体验差')
        .set(5, '其他')

      return hashMap.get(value) || ''
    },
    // 0:评价待处理，1:评价已处理，2:挂起，3:评价不合理
    formatStatusEnums(value) {
      const hashMap = new Map()
        .set(0, '评价待处理')
        .set(1, '评价已处理')
        .set(2, '挂起')
        .set(3, '评价不合理')
      return hashMap.get(value) || ''
    },
    formatTime(value) {
      return dayjs(value).format('YYYY-MM-DD')
    }
  },
  mounted() {
    this.getDedaultPageDataOftable()
  },
  activated() {
    this.getDedaultPageDataOftable()
  },
  methods: {
    handleClose() {
      this.$emit('close', false)
    },
    paginationChange() {
      this.getDedaultPageDataOftable()
    },
    async getDedaultPageDataOftable() {
      try {
        const day = dayjs()

        const formattedToday = day.format('YYYY-MM-DD HH:mm:ss')
        const threeMonthsAgo = day.subtract(3, 'month')
        const formattedThreeMonthsAgo = threeMonthsAgo.format('YYYY-MM-DD HH:mm:ss')

        const { page } = this.listQuery
        const res = await request({
          url: '/customer/bizUnitRectifyFeedbackDetailData',
          method: 'get',
          params: {
            // beginTime: formattedThreeMonthsAgo,
            // endTime: formattedToday,
            unitCode: this.unitCode,
            pageNum: page || 1,
            pageSize: 10
          },
          headers: {
            'Content-Type': 'x-www-form-urlencoded',
          },
        })
        const { data } = res
        const { list, total } = data
        this.listQuery.total = total
        this.pageDataOftable = list || []
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.rectification-boards-table {
  overflow: hidden;
  max-height: 380px;
  .has-gutter {
    .tr {
      background-color: #f4f4f5;
    }
  }
  .boards-table-row {
    font-size: 14px;
    line-height: 20px !important;
    color: #525765;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    cursor: pointer;
  }
  /deep/.boards-table-column {
      td {
      padding: 8px 0;

    }
  }
  &::before {
    display: none;
  }
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #FAFAFB !important;
}
</style>
